import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileSendSafetyConfirmToOtherUserState {
  /** 安否確認ID */
  safetyConfirmId: number | null;
  /**
   * 宛先グループ
   * import { SafetyConfirmTargetMessageGroupModalModel } from "@/mobile/components/modals/SafetyConfirmTargetMessageGroupModal.vue";
   * したいが、エラーになるのでanyで代用
   */
  groupTargets: Array<any>;
  /** 冒頭文 */
  openingSentence: string;
  /** 質問内容表示情報 */
  questionsLabel: string;
  /** 質問のID配列 */
  useIds: Array<number>;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileSendSafetyConfirmToOtherUser store
 *
 * - store
 *   - 安否確認送信(施設関係者)画面の入力情報を保持する
 * - action, mutation
 *   - 安否確認送信(施設関係者)画面の入力情報を格納する
 */
@Module({ name: "mobileSendSafetyConfirmToOtherUser" })
export default class MobileSendSafetyConfirmToOtherUser extends VuexModule implements MobileSendSafetyConfirmToOtherUserState {
  safetyConfirmId = null;
  groupTargets: Array<any> = [];
  openingSentence = "";
  questionsLabel = "";
  useIds = [];
  updated = null;
  exist = false;

  /** stateのgetters */
  get mobileSendSafetyConfirmToOtherUserState(): MobileSendSafetyConfirmToOtherUserState {
    const state: MobileSendSafetyConfirmToOtherUserState = {
      safetyConfirmId: this.safetyConfirmId,
      groupTargets: this.groupTargets,
      openingSentence: this.openingSentence,
      questionsLabel: this.questionsLabel,
      useIds: this.useIds,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_SEND_SAFETY_CONFIRM_TO_OTHERUSER(state: MobileSendSafetyConfirmToOtherUserState) {
    this.safetyConfirmId = state.safetyConfirmId as any;
    this.groupTargets = state.groupTargets;
    this.openingSentence = state.openingSentence;
    this.questionsLabel = state.questionsLabel;
    this.useIds = state.useIds as any;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_SEND_SAFETY_CONFIRM_TO_OTHERUSER() {
    this.safetyConfirmId = null;
    this.groupTargets = [];
    this.openingSentence = "";
    this.questionsLabel = "";
    this.useIds = [];
    this.exist = false;
    return;
  }

  /**
   * ### 安否確認送信(施設関係者)画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileSendSafetyConfirmToOtherUserState(payload: { state: MobileSendSafetyConfirmToOtherUserState }): void {
    this.SET_MOBILE_SEND_SAFETY_CONFIRM_TO_OTHERUSER(payload.state);
    return;
  }

  /**
   * ### 安否確認送信(施設関係者)画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileSendSafetyConfirmToOtherUserState(): void {
    this.RESET_MOBILE_SEND_SAFETY_CONFIRM_TO_OTHERUSER();
    return;
  }
}
